const app = new Vue({
    el: '#app',
    data() {
        return {
            show_subject: false,
            subject: null,
            subject_labels: {},
        };
    },
    methods: {
        setSubject(subject) {
            this.show_subject = false;
            this.subject = subject;
        }
    },
    computed: {
        subjectLabel() {
            if (this.subject) {
                if (this.subject_labels.hasOwnProperty(this.subject)) {
                    return this.subject_labels[ this.subject ];
                }
            }
            return this.$options.filters['lang']('copy.select_subject');
        }
    },
    mounted() {
        this.subject_labels = {
            partner: this.$options.filters['lang']('copy.i_want_to_be_a_partner'),
            join: this.$options.filters['lang']('copy.i_want_to_join_community'),
            sms: this.$options.filters['lang']('copy.i_did_not_get_authentication'),
            tool: this.$options.filters['lang']('copy.i_want_to_nominate_tool'),
            blog: this.$options.filters['lang']('copy.blog'),
            other: this.$options.filters['lang']('copy.Other'),
        };
    }
})